import { useState } from "react";
import { getIDsDeAplicacionesDeUnaFactura } from "../services/facturaService";

export const useGetIDsDeAplicaciones = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const execute = async (idFactura) => {
    try {
      setLoading(true);
      setError(null);

      const res = await getIDsDeAplicacionesDeUnaFactura(idFactura);

      return res;
    } catch (error) {
      setError(error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return {
    execute,
    loading,
    error,
  };
};
